import { Model } from '@nozbe/watermelondb'
import { field } from '@nozbe/watermelondb/decorators'


export class ShoppingOrganizationModel extends Model {
  static table = 'shoppingOrganization'

  @field('shoppingOrganizationId')
  shoppingOrganizationId: string

  @field('active')
  active: boolean

  @field('addressComplement')
  addressComplement: string

  @field('city')
  city: string

  @field('companyDocument')
  companyDocument: string

  @field('companyName')
  companyName: string

  @field('country')
  country: string

  @field('createdAt')
  createdAt: string

  @field('district')
  district: string

  @field('isSubsidiary')
  isSubsidiary: boolean

  @field('nfe')
  nfe: boolean

  @field('number')
  number: string

  @field('organizationId')
  organizationId: string

  @field('postalCode')
  postalCode: string

  @field('state')
  state: string

  @field('stateRegistration')
  stateRegistration: string

  @field('street')
  street: string

  @field('tradeName')
  tradeName: string

  @field('updatedAt')
  updatedAt: string

  @field('type')
  type: number

}
